"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[214],{

/***/ 93214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46159);
/**
 * Used to asynchronously load framer motion
 * @link https://www.framer.com/docs/guide-reduce-bundle-size/#async-loading
 */

/* harmony default export */ __webpack_exports__["default"] = (framer_motion__WEBPACK_IMPORTED_MODULE_0__/* .domAnimation */ .H);

/***/ })

}]);